// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Button,
  Divider,
  // TableContainer,
  // Paper,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
// import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

function OrderPage() {
  const pageTitle = "Order View";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [order, setOrder] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [products, setProducts] = useState([]);
  const [dataForm, setDataForm] = useState(null);
  const [shippingOption, setShippingOption] = useState(null);
  const [shippingInformation, setShippingInformation] = useState(null);

  function getProductObjects(row) {
    return (
      <>
        {Object.entries(row).map(([key, value]) => (
          <MDTypography variant="h6" fontWeight="light" fontSize={13}>
            {(key.charAt(0).toUpperCase() + key.slice(1)).replace("_", " ")}: {value}
          </MDTypography>
        ))}
      </>
    );
  }

  const tableProductColumns = [
    // { Header: "Reference", accessor: "reference", align: "left" },
    { Header: "Product", accessor: "name", align: "left" },
    { Header: "Unit Price", accessor: "price", align: "left" },
    { Header: "Quantity", accessor: "quantity", align: "left" },
    { Header: "Options", accessor: "options", align: "left" },
    { Header: "Items", accessor: "items", align: "left" },
  ];

  const buildProductRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        // reference: row.reference,
        name: row.name,
        price: (
          <>
            <small>{currency}</small>
            {(row.price / 100).toLocaleString("en", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </>
        ),
        quantity: row.quantity,
        options:
          row.variants.length > 0 ? (
            <MDBox mt={1}>
              <MDTypography>
                {row.variants.map((variant) => (
                  <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                    {variant.variant_title}
                    :&nbsp;{variant.option_title}
                  </MDTypography>
                ))}
              </MDTypography>
            </MDBox>
          ) : (
            "N/A"
          ),
        items:
          row.product_objects.length > 0 ? (
            <MDBox mt={1}>
              <MDTypography>
                {row.product_objects.map((productObject) => (
                  <>{getProductObjects(productObject)}</>
                ))}
              </MDTypography>
            </MDBox>
          ) : (
            "N/A"
          ),
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/campaigns/orders/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            console.log(result.data.data);
            setOrder(result.data.data.order);
            setCurrency(result.data.data.currency);
            const productsRows = buildProductRows(result.data.data.order.order.products);
            setProducts(productsRows);
            setDataForm(result.data.data.order.data_form);
            setShippingOption(result.data.data.order.shipping_option);
            if (result.data.data.order.shipping_information !== null) {
              setShippingInformation(result.data.data.order.shipping_information);
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function getMediaElement(vrf, v) {
    if (v.startsWith("data:image")) {
      return (
        <MDBox
          onClick={async () => {
            const response = await fetch(v);
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, "_blank");
            URL.revokeObjectURL(blobUrl);
          }}
        >
          <img src={v} alt="" width={120} />
        </MDBox>
      );
    }

    if (v.startsWith("data:audio")) {
      return (
        <audio src={v} controls>
          <track default kind="captions" srcLang="en" />
        </audio>
      );
    }

    if (v.startsWith("data:video")) {
      return (
        <video src={v} height={150} controls>
          <track default kind="captions" srcLang="en" />
        </video>
      );
    }

    // Link it externally
    if (v.startsWith("data:")) {
      return (
        <MDBox>
          <a href={`${AppConfig.api_base_url}dff/dl/${vrf}`} target="_blank" rel="noreferrer">
            PREVIEW
          </a>
        </MDBox>
      );
    }

    return v;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {order !== null ? (
        <MDBox pt={3} pb={3}>
          <MDBox>
            <Button
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate(`/campaigns/${order.campaign.reference}/sales`);
              }}
            >
              Back
            </Button>
          </MDBox>
          <MDBox mt={1}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <Card>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Order Details
                        </MDTypography>
                        <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                          <Icon color="success">receipt</Icon>
                        </MDBox>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDBox>
                          <Table aria-label="campaign information">
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Reference
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {order.order.reference}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Campaign
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {order.campaign.name}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              {order.campaign_location ? (
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Campaign Location
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {order.campaign_location.name}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                <> </>
                              )}
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Order Amount
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    <small>{currency}</small>
                                    {(order.order.amount / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              {order.order.shipping_fee > 0 ? (
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Shipping Amount
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      <small>{currency}</small>
                                      {(order.order.shipping_fee / 100).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                <> </>
                              )}
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Payment Fee
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    <small>{currency}</small>
                                    {(order.order.transaction_fee / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Platform Fee
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    <small>{currency}</small>
                                    {(order.order.platform_fee / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Amount Settled
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    <small>{currency}</small>
                                    {(order.order.amount_settled / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Payment Method
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {order.order.payment_method}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Location
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    <a
                                      rel="noreferrer"
                                      target="_blank"
                                      href={`https://maps.google.com?q=${order.meta.latitude},${order.meta.longitude}`}
                                    >
                                      <Icon>location_on</Icon>
                                    </a>
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Date
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {order.order.date}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card>
                    <MDBox mb={3}>
                      <MDBox p={2}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                            Agent Details
                          </MDTypography>
                          <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                            <Icon color="warning">support_agent</Icon>
                          </MDBox>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDBox>
                            <Table>
                              <TableBody>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Name
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {order.agent.name}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Staff ID
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {order.agent.staff_number ? order.agent.staff_number : "N/A"}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
                {order.customer ? (
                  <MDBox mt={9}>
                    <Card>
                      <MDBox mb={3}>
                        <MDBox p={2}>
                          <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              textTransform="capitalize"
                            >
                              Customer Details
                            </MDTypography>
                            <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                              <Icon color="info">person</Icon>
                            </MDBox>
                          </MDBox>
                          <MDBox mt={3}>
                            <MDBox>
                              <Table aria-label="campaign information">
                                <TableBody>
                                  <TableRow>
                                    <TableCell>
                                      <MDTypography variant="h6" fontWeight="regular">
                                        Name
                                      </MDTypography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <MDTypography variant="h6" fontWeight="light">
                                        {order.customer.name}
                                      </MDTypography>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <MDTypography variant="h6" fontWeight="regular">
                                        Email Address
                                      </MDTypography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <MDTypography variant="h6" fontWeight="light">
                                        {order.customer.email_address}
                                      </MDTypography>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <MDTypography variant="h6" fontWeight="regular">
                                        Phone Number
                                      </MDTypography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <MDTypography variant="h6" fontWeight="light">
                                        {order.customer.phone_number}
                                      </MDTypography>
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                ) : (
                  <MDBox mt={9}>
                    <Card>
                      <MDBox p={3} align="center">
                        <MDTypography variant="h6" fontSize={36}>
                          <Icon>person</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="regular" fontSize={16}>
                          No customer details available
                        </MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                )}
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={5}>
            <Card>
              <MDBox>
                <MDBox p={3} display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    Order Items
                  </MDTypography>
                  <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                    <Icon color="dark">list</Icon>
                  </MDBox>
                </MDBox>
                <DataTable
                  table={{ columns: tableProductColumns, rows: products }}
                  isSorted
                  entriesPerPage={false}
                  showTotalEntries
                  buttons
                  noEndBorder
                />
              </MDBox>
            </Card>
          </MDBox>
          {dataForm !== null ? (
            <MDBox mt={5}>
              <Card>
                <MDBox>
                  <MDBox p={3} display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                      Data Form
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                      <Icon color="dark">list_alt</Icon>
                    </MDBox>
                  </MDBox>
                  <MDBox mt={1} px={1}>
                    {Object.entries(dataForm).map(([i, section]) => (
                      <MDBox id={`ref_${i}`} mb={2}>
                        <MDBox ml={2}>
                          <MDTypography variant="h6" fontWeight="bold" textTransform="capitalize">
                            {section.name}
                          </MDTypography>
                          <Divider />
                        </MDBox>
                        <Table aria-label="campaign information">
                          <TableBody>
                            {section.items.map((item) => (
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    {item.name}
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  {/* <MDTypography variant="h6" fontWeight="light">
                                    {typeof item.value === "object" ? (
                                      <>
                                        {Object.entries(item.value).map(([x, y]) => (
                                          <>
                                            <MDTypography
                                              variant="h6"
                                              fontWeight="regular"
                                              fontSize={14}
                                            >
                                              {x}
                                            </MDTypography>
                                            <MDTypography variant="h6" fontWeight="light">
                                              {y}
                                            </MDTypography>
                                          </>
                                        ))}
                                      </>
                                    ) : (
                                      <MDBox>
                                        {typeof item.value === "string" ? (
                                          getMediaElement(item.reference, item.value)
                                        ) : (
                                          <span>{item.value}</span>
                                        )}
                                      </MDBox>
                                    )}
                                  </MDTypography> */}
                                  <MDBox>
                                    {typeof item.value === "object" ? (
                                      <MDBox>
                                        {Array.isArray(item.value) ? (
                                          <MDBox>
                                            {item.value.map((objRow) =>
                                              Object.entries(objRow).map(([x, y]) => (
                                                <>
                                                  <MDTypography
                                                    variant="text"
                                                    fontWeight="regular"
                                                    fontSize={15}
                                                  >
                                                    {x}
                                                  </MDTypography>
                                                  <MDTypography
                                                    fontSize={15}
                                                    variant="text"
                                                    fontWeight="light"
                                                  >
                                                    {y}
                                                  </MDTypography>
                                                </>
                                              ))
                                            )}
                                          </MDBox>
                                        ) : (
                                          <div>
                                            {Object.entries(item.value).map(([x, y]) => (
                                              <div>
                                                <MDTypography
                                                  variant="text"
                                                  fontWeight="regular"
                                                  fontSize={15}
                                                >
                                                  {x}
                                                </MDTypography>
                                                <MDTypography
                                                  fontSize={15}
                                                  variant="text"
                                                  fontWeight="light"
                                                >
                                                  {y}
                                                </MDTypography>
                                              </div>
                                            ))}
                                          </div>
                                        )}
                                      </MDBox>
                                    ) : (
                                      <div>
                                        {typeof item.value === "string" ? (
                                          getMediaElement(item.reference, item.value)
                                        ) : (
                                          <MDTypography
                                            variant="text"
                                            fontWeight="light"
                                            fontSize={15}
                                            style={{ wordWrap: "break-word" }}
                                          >
                                            {item.value}
                                          </MDTypography>
                                        )}
                                      </div>
                                    )}
                                  </MDBox>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </MDBox>
                    ))}
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          ) : (
            <> </>
          )}
          {shippingInformation !== null ? (
            <MDBox mt={5}>
              <Card>
                <MDBox>
                  <MDBox p={3} display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                      Shipping Information
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                      <Icon color="dark">local_shipping</Icon>
                    </MDBox>
                  </MDBox>
                  <MDBox mt={1} px={1}>
                    <Table aria-label="campaign information">
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="regular">
                              Receiver Name
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {shippingInformation.name}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="regular">
                              Phone Number
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {shippingInformation.phone_number}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="regular">
                              Address
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {shippingInformation.address}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="regular">
                              GPS Location
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              <a
                                rel="noreferrer"
                                target="_blank"
                                href={`https://maps.google.com?q=${shippingInformation.latitude},${shippingInformation.longitude}`}
                              >
                                <Icon>location_on</Icon>
                              </a>
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="regular">
                              City
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {shippingInformation.city}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="regular">
                              State
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {shippingInformation.state}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="regular">
                              Country
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {shippingInformation.country}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          ) : (
            <> </>
          )}
          {shippingOption !== null ? (
            <MDBox mt={5}>
              <Card>
                <MDBox>
                  <MDBox p={3} display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                      Shipping Fee
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                      <Icon color="dark">place</Icon>
                    </MDBox>
                  </MDBox>
                  <MDBox mt={1} px={1}>
                    <Table aria-label="campaign information">
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="regular">
                              State
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {shippingOption.state}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="regular">
                              Coverage
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              {shippingOption.coverage}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="regular">
                              Fee
                            </MDTypography>
                          </TableCell>
                          <TableCell align="right">
                            <MDTypography variant="h6" fontWeight="light">
                              <small>{currency}</small>
                              {(shippingOption.fee / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          ) : (
            <> </>
          )}
        </MDBox>
      ) : (
        <> </>
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default OrderPage;
